import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { IAlarmInformation } from "../../services/admin-report-data-service/Models";
import AdminReportDataService from "../../services/admin-report-data-service/AdminReportDataService";

export type UseAlarmNotificationAdminReportParams = {
    contextGroupID: number,
    startDate: Date | undefined,
    endDate: Date | undefined
} & BaseUseQueryParameters<IAlarmInformation[] | undefined>;

export function useAlarmNotificationAdminReport({
    contextGroupID,
    startDate,
    endDate,
    enabled,    
    onSuccess,
    onError
}: UseAlarmNotificationAdminReportParams) {
    return useQuery<IAlarmInformation[], RestError>(
        keys.alarmNotificationsAdminReport(contextGroupID, startDate, endDate),
        ({ signal }) => {
            return AdminReportDataService.getAlarmNotifications(
                contextGroupID,
                startDate,
                endDate,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
        }
    );
}